module.exports = __webpack_public_path__ + "static/img_partnerNftHorizonHovered-1a93433941eb95f629c341758d2f0c63.png";